// Copyright © 2026 Qcells. All rights reserved.
//
// This software is proprietary and confidential. Unauthorized use,
// duplication, or distribution of software is strictly prohibited.

/**
 * HITL (Human-in-the-Loop) approval/review types.
 * Mirrors the BFF's app/schemas/hitl.py.
 */

export type HitlApprovalState = 'PENDING' | 'APPROVED' | 'REJECTED';

/** Display/sort rank for approval states; anything else (or missing) sorts last. */
export const HITL_APPROVAL_STATUS_ORDER: Record<string, number> = {
  PENDING: 0,
  APPROVED: 1,
  REJECTED: 2,
};

export interface HitlReviewSummary {
  reviewId: string;
  state: HitlApprovalState;
  attributes?: Record<string, unknown> | null;
}

export interface HitlApproval {
  approvalId: string;
  approvalType: string;
  siteId: string;
  state: HitlApprovalState;
  attributes?: Record<string, unknown> | null;
  reviews: HitlReviewSummary[];
  createdAt?: string | null;
  updatedAt?: string | null;
}

export interface HitlDecisionRequest {
  decision: 'APPROVED' | 'REJECTED';
  comment?: string;
}

export interface HitlDecision {
  reviewId: string;
  decision: HitlApprovalState;
  comment?: string | null;
}
